import { useEffect, useState } from 'react';
import './XpToast.css';

interface Toast {
  id: number;
  amount: number;
  big: boolean;
}

let nextId = 0;

function XpToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { amount } = (e as CustomEvent<{ amount: number }>).detail;
      const big = amount >= 25;
      const id = nextId++;
      setToasts(prev => [...prev, { id, amount, big }]);
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, big ? 3500 : 2500);
    };

    window.addEventListener('xp:earned', handler);
    return () => window.removeEventListener('xp:earned', handler);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="xp-toast-layer" aria-live="polite">
      {toasts.map((t, i) => (
        <div
          key={t.id}
          className={`xp-toast${t.big ? ' xp-toast--big' : ''}`}
          style={{ '--offset': i } as React.CSSProperties}
        >
          {t.big ? (
            <>
              <span className="xp-toast-icon">🏆</span>
              Session bonus +{t.amount} XP
              <span className="xp-toast-icon">⚡</span>
            </>
          ) : (
            <>
              <span className="xp-toast-icon">⚡</span>
              +{t.amount} XP
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default XpToast;
